import * as Types from '../../../../.graphql/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetCustomerNotesQueryVariables = Types.Exact<{
  customerId: Types.Scalars['Int']['input'];
}>;


export type GetCustomerNotesQuery = { __typename?: 'Query', customer: { __typename?: 'CustomerExtensions', myCustomer: { __typename?: 'MyCustomer', notes?: string | null } } };

export const GetCustomerNotesDocument = gql`
    query GetCustomerNotes($customerId: Int!) {
  customer {
    myCustomer(customerId: $customerId) {
      notes
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomerNotesGQL extends Apollo.Query<GetCustomerNotesQuery, GetCustomerNotesQueryVariables> {
    document = GetCustomerNotesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }